import _ from "lodash";
import { IClientConfig } from "src/client-config/config";
import { ProductTypeEnum } from "src/constants/enums/productType";
import { storeGetConfig } from "src/stores/upperData";

const checkProductType = (productType: ProductTypeEnum, config?: IClientConfig) => {
  if (config) return config.productType === ProductTypeEnum[productType];
  
  const storeConfig = storeGetConfig();
  return storeConfig.productType === ProductTypeEnum[productType];
};

export const isTerminal = _.partial(checkProductType, ProductTypeEnum.Terminal);
export const isCashier = _.partial(checkProductType, ProductTypeEnum.Cashier);